/**
 * @doc Editor
 */
export var PanelType;
(function (PanelType) {
    PanelType["Settings"] = "settings";
    PanelType["Layout"] = "layout";
    PanelType["Design"] = "design";
    PanelType["Upgrade"] = "upgrade";
    PanelType["Add"] = "add";
})(PanelType || (PanelType = {}));
/**
 * @doc Editor
 */
export var PanelResolveType;
(function (PanelResolveType) {
    PanelResolveType["MAIN_ACTION"] = "mainActionClicked";
    PanelResolveType["SECONDARY_ACTION"] = "secActionClicked";
    PanelResolveType["CLOSE_ACTION"] = "closeActionClicked";
})(PanelResolveType || (PanelResolveType = {}));
/**
 * @doc Editor
 */
export var PagesPanelTabType;
(function (PagesPanelTabType) {
    PagesPanelTabType["PageInfo"] = "page_info";
    PagesPanelTabType["Layout"] = "layout";
    PagesPanelTabType["Permissions"] = "permissions";
    PagesPanelTabType["SEO"] = "seo";
})(PagesPanelTabType || (PagesPanelTabType = {}));
export var customizeActions;
(function (customizeActions) {
    customizeActions["Custom"] = "Custom";
})(customizeActions || (customizeActions = {}));
//# sourceMappingURL=panels.js.map